import React, {Fragment} from "react";
import {Link} from "react-router";

import Panel from "./Panel";
import Right from "./Right";
import FormItem from "./FormItem";

import langs from "./langs/appIndex";
import phpLangs from "./langs/phpIndex";

import {api, BRANCH_IPS} from "./baseFunctions";


export default class ServerPage extends React.Component {
    state = {
        loading: false,
    };

    async apiWrapper(endpoint, IP)
    {
        return new Promise(r => api("POST", {"type": endpoint}, d => r(d), this.props.auth, true, IP));
    }

    async restore()
    {
        const check = window.confirm("Er du sikker på dette?");
        if(check)
        {
            this.setState({loading: 1});
            const backupResp = await this.apiWrapper(`makeBackup`, BRANCH_IPS.PROD);

            this.setState({loading: 2});
            setTimeout(() => this.setState({loading: 3}), 500);
            const resp = await this.apiWrapper("restoreBackup", BRANCH_IPS.DEV);
            this.setState({loading: false});
            if(!resp.error)
            {
                alert("Databasen er restored!");
            }
        }
    }

    render(){
        const editing = this.state.editing;
        return (<Right title="Server stuff" token={this.props.auth} lang={this.props.lang}>
          
            <Panel title="Clone production DB">
                Restore produktions databasen i development.<br/>
                <b>Beaware:</b> Den nuværende development DB bliver clearet før databasen restores.<br/>
               
               {
                   this.state.loading === false ? <button onClick={() => this.restore()}>Restore</button> : <br/>
               }
               
               {
                   this.state.loading === 1 && <b>Backing up production..</b>
               }
               
               {
                   this.state.loading === 2 && <b>Downloading backup..</b>
               }
               
               {
                   this.state.loading === 3 && <b>Restoring backup..</b>
               }
                
            </Panel>

        </Right>);
    }
}


// WEBPACK FOOTER //
// ./src/components/ServerPage.js